/**
 * Created by Alican Köker on 2018-12-19.
 */
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";

export class EdisonGameMode extends GameMode {
    static readonly STACKED_RESPIN:string = "STACKED_RESPIN";
}